/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
// import { toastEmmit } from "../../../../Helper/Toastr";
import {
  showDeleteConfirmation,
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import Switch from "@mui/material/Switch";
import MoonLoader from "react-spinners/MoonLoader";
import Pagination from "../../../../Helper/Pagination";

export default function ManageSEO() {
  const [gallerywallList, setGallerywallList] = useState();
  const [TotalPageCount, SetTotalPageCount] = useState();
  const [TotalCount, SetTotalCount] = useState();
  const [S_No_Count, setCount] = useState(0);
  const [search_key, setsearch_key] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [submitLoader, setsubmitLoader] = useState(false);

  const [selectedData, setSelectedData] = useState("");

  useEffect(() => {
    getGalleryWallList();
  }, [search_key, currentPage]);

  const getGalleryWallList = () => {
    setLoading(true);

    const param = {
      limit: 10,
      page: currentPage,
      sorting: "sortingKey|desc",
      search_key: search_key,
    };

    PostService(API_URL.GET_SEO_LIST, param).then((res) => {
      if (res?.data?.status === true) {
        setGallerywallList(res.data.data.rows);
        SetTotalPageCount(res.data.totalPages);
        SetTotalCount(res.data.totalItems);
        setCount(res.data.currentPage * param.limit);
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  const [error, setError] = useState(false);

  const [page_name, setpage_name] = useState("");
  const [meta_title, setmeta_title] = useState();
  const [meta_name, setmeta_name] = useState("");
  const [meta_desc, setmeta_desc] = useState();
  const [status, setStatus] = useState("");

  useEffect(() => {
    console.log(selectedData);
    setpage_name(selectedData?.page_name);
    setmeta_title(selectedData?.meta_title);
    setmeta_name(selectedData?.meta_name);
    setmeta_desc(selectedData?.meta_desc);
    setStatus(selectedData?.status);
  }, [selectedData]);

  const submit = (e) => {
    e.preventDefault();

    if (!page_name || !meta_title || !meta_name || !meta_desc) {
      setError(true);
      return;
    }

    setsubmitLoader(true);

    let formdata = {
      id: selectedData?.page_id,
      page_name,
      meta_title,
      meta_name,
      meta_desc
    };

    PostService(API_URL.UPDATE_SEO_LIST, formdata).then(
      (res) => {
        console.log(res);
        if (res.data.status === true) {
          showSuccessAlert(res?.data?.message, getGalleryWallList);
          resetFunc();
          // getContentList();
          document.getElementById("closeEditModal").click();
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const changeStatus = async (id, status) => {
    const data = {
      id: id,
      status: status === "active" ? "inactive" : "active",
    };

    PostService(API_URL.CHANGE_STATUS_SEO_LIST, data).then(
      (res) => {
        if (res.data.status) {
          showSuccessAlert(res?.data?.message, getGalleryWallList);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  };

  const handlePageClick = (e) => {
    setCurrentPage(e - 1);
  };

  function resetFunc() {
    setStatus();
    setError(false);
    setsubmitLoader(false);
  }

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3 className="default_color">SEO List</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">SEO List</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-4 offset-md-8 p-0">
                      <nav className="navbar">
                        <input
                          className="form-control"
                          type="text"
                          name="firstnamesearch"
                          placeholder="Search by Keyword"
                          autoComplete="off"
                          onChange={(e) => {
                            setTimeout(() => {
                              setsearch_key(e.target.value);
                              setCurrentPage(0);
                            }, 400);
                          }}
                        />
                      </nav>
                    </div>
                  </div>

                  <div className="table-responsive">
                    {!loading && (
                      <table className="table table-hover text-nowrap table-striped table-bordered">
                        <thead>
                          <tr>
                            <th className="text-center">S.No</th>
                            <th className="text-center">Page Name</th>
                            <th className="text-center">Page Title</th>
                            <th className="text-center">Status</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gallerywallList?.map((data, i) => (
                            <tr key={i} className="text-center">
                              <td className="text-center">
                                {i + S_No_Count + 1}
                              </td>
                              <td className="text-center">
                                {data?.page_name ? data?.page_name : "N/A"}
                              </td>
                              <td className="text-center">
                                {data?.meta_title ? data?.meta_title : "N/A"}
                              </td>
                              <td className="text-center">
                                <span
                                  className={
                                    data?.status === "active"
                                      ? "badge badge-success"
                                      : "badge badge-danger"
                                  }
                                >
                                  {data?.status}
                                </span>
                              </td>
                              <td className="text-center">
                                <span className="toggle-switch">
                                  <Switch
                                    checked={data?.status === "active"}
                                    onChange={() => {
                                      changeStatus(data?.page_id, data.status);
                                    }}
                                    size="small"
                                    color="primary" // You can customize the color
                                    inputProps={{
                                      "aria-label": "toggle switch",
                                    }}
                                  />
                                </span>
                                <span
                                  title="Update"
                                  style={{ cursor: "pointer" }}
                                  className="mx-2"
                                  data-toggle="modal"
                                  data-target="#EditModal"
                                  onClick={() => {
                                    setSelectedData(data);
                                  }}
                                >
                                  <i className="text-dark fas fa-pen"></i>{" "}
                                </span>
                              </td>
                            </tr>
                          ))}
                          {gallerywallList && gallerywallList.length === 0 && (
                            <tr>
                              <td colSpan="5" className="text-center">
                                <h6 className="p-3"> No Data Found </h6>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {loading ? (
                      <div className="LoaderSpinner">
                        <MoonLoader
                          color={"#003bff"}
                          loading={loading}
                          speedMultiplier={0.6}
                          size={50}
                        />
                        <div>Loading... Please wait.</div>
                      </div>
                    ) : (
                      ""
                    )}

                    <div className="mt-4">
                      <Pagination
                        counting={S_No_Count}
                        totaldata={TotalCount}
                        pagecount={TotalPageCount}
                        onChangePage={handlePageClick}
                        activePage={currentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className="modal fade"
        id="EditModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title" id="exampleModalLabel">
                Edit
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFunc}
              >
                {" "}
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <form onSubmit={(e) => submit(e)}>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label>Meta Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        value={meta_name}
                        onChange={(e) => setmeta_name(e?.target?.value)}
                        placeholder="Meta Name"
                      />
                      {error && !meta_name && (
                        <div className="error mt-1">Meta Name is required</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label>Meta Description</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Meta Description"
                        value={meta_desc}
                        onChange={(e) => setmeta_desc(e?.target?.value)}
                      />
                      {error && !meta_desc && (
                        <div className="error mt-1">
                          Meta Description is required
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label>Page Name</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Page Name"
                        value={page_name}
                        onChange={(e) => setpage_name(e?.target?.value)}
                      />
                      {error && !page_name && (
                        <div className="error mt-1">Page Name is required</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label>Page Title</label>
                      <textarea 
                        className="form-control"
                        placeholder="Meta Title"
                        value={meta_title}
                        onChange={(e) => setmeta_title(e?.target?.value)}
                      > </textarea>
                      {error && !meta_title && (
                        <div className="error mt-1">Page Title is required</div>
                      )} 
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  id="closeEditModal"
                  data-dismiss="modal"
                  onClick={resetFunc}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={submitLoader}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Update"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
